export var retryErrors = ['InvalidAccessKeyId', 'SecurityTokenExpired'];
export var networkErrors = ['RequestTimeout', 'ConnectionTimeoutError', 'RequestError'];
var errorCodes = [].concat(retryErrors, networkErrors);
export default errorCodes;